<db-dialog-wrapper [dialog]="this" [width]="'500px'" [height]="'243px'">
  <div class="db-third-party-theme-activation-dialog">
    <div>
      <h1>{{'text_thirdPartyThemeTitle' | dbText}}</h1>
      <p [innerHTML]="'text_aiBuilder__notice-desc' | dbText"></p>
    </div>

    <div class="db-third-party-theme-activation-dialog__buttons">
      <a class="db-button" [ngClass]="{'db-button_disabled': loading}" (click)="cancel()"><span>{{'text_cancel' | dbText}}</span></a>
      <a class="db-button db-button_info" [ngClass]="{'db-button_disabled': loading}" (click)="confirm()">
        <span *ngIf="!loading" >{{'text_activate' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
